import { render } from "./BaseAddPoint.vue?vue&type=template&id=fa3b6748&scoped=true&ts=true"
import script from "./BaseAddPoint.vue?vue&type=script&lang=ts"
export * from "./BaseAddPoint.vue?vue&type=script&lang=ts"

import "./BaseAddPoint.vue?vue&type=style&index=0&id=fa3b6748&scoped=true&lang=scss"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa3b6748"]])

export default __exports__